import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { IconButton } from '@ds';

type RoutePaginationProps = {
  currentPage: number;
  pages: number;
  onPrevious: () => void;
  onNext: () => void;
};

export const RoutePagination = ({ currentPage, pages, onPrevious, onNext }: RoutePaginationProps) => {
  return (
    <div className="flex gap-2 items-center">
      <IconButton
        size="sm"
        radius="full"
        variant="action"
        onPress={onPrevious}
        isDisabled={!currentPage}
        startContent={<MdOutlineKeyboardArrowLeft size={18} />}
      />
      <span className="text-m-sb text-base-5">{`${currentPage + 1} of ${pages}`}</span>
      <IconButton
        size="sm"
        variant="action"
        radius="full"
        onPress={onNext}
        isDisabled={currentPage + 1 === pages}
        startContent={<MdOutlineKeyboardArrowRight size={18} />}
      />
    </div>
  );
};
